import {
    gameNamePrefixes, gameNameSuffixes,
    trGameNamePrefixes, trGameNameSuffixes,
    frGameNamePrefixes, frGameNameSuffixes
} from '@/constants/gameNames';

export interface GameNameGeneratorOptions {
    count?: number;
    style?: 'fantasy' | 'sci-fi' | 'modern' | 'any';
    locale?: string;
}

export function generateGameNames(options: GameNameGeneratorOptions = {}): string[] {
    const count = options.count || 10;
    const locale = options.locale || 'en';
    const names: string[] = [];

    const getLocaleData = (lang: string) => {
        switch (lang) {
            case 'tr':
                return {
                    prefixes: trGameNamePrefixes,
                    suffixes: trGameNameSuffixes,
                    thePrefix: '' // Turkish doesn't have "The" article
                };
            case 'fr':
                return {
                    prefixes: frGameNamePrefixes,
                    suffixes: frGameNameSuffixes,
                    thePrefix: 'Le ' // Or La/Les, but keeping simple for now
                };
            default: // en
                return {
                    prefixes: gameNamePrefixes,
                    suffixes: gameNameSuffixes,
                    thePrefix: 'The '
                };
        }
    };

    const data = getLocaleData(locale);

    for (let i = 0; i < count; i++) {
        const prefix = data.prefixes[Math.floor(Math.random() * data.prefixes.length)];
        const suffix = data.suffixes[Math.floor(Math.random() * data.suffixes.length)];

        // 10% chance to have a "The" prefix (if applicable)
        const hasThe = Math.random() < 0.1 && data.thePrefix !== '';

        // 20% chance to have a number at the end
        const hasNumber = Math.random() < 0.2;
        const number = hasNumber ? ` ${Math.floor(Math.random() * 9) + 2}` : ''; // 2-10

        let name = `${prefix} ${suffix}${number}`;
        if (hasThe) {
            name = `${data.thePrefix}${name}`;
        }

        names.push(name);
    }

    return names;
}
